<template>
  <!--
    Example Data
    { name: 'foo', input_type: "select", options: ['list', 'of', 'values'], label: optional}
  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ fieldLabel | capitalize }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="9" >
        <v-select
          :items="labeledItems"
          :label="fieldLabel | capitalize"
          :value="cval"
          :rules="vruleFieldRequired"
          required
          v-on:change="updateQueryParamValue(value.name, $event)"
        ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import Titleize from '@/components/filters/titleize'

export default {
  name: 'select-input-field',
  inputType: 'select',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    fieldLabel () {
      if (this.value) {
        if (this.value.label) {
          return this.value.label
        } else {
          return this.value.name
        }
      } else {
        return ''
      }
    },
    labeledItems () {
      return this.value.options.map((option) => {
        return { text: Titleize.titleize(option), value: option }
      })
    },
    cval () {
      if (this.modelValue[this.value.name]) {
        return this.modelValue[this.value.name]
      } else if (this.value.default) { // no value - check if default set. If you do not, creates an infinite loop
        this.updateQueryParamValue(this.value.name, this.value.default)
        return ''
      } else {
        return ''
      }
    }
  },
  methods: {
    updateQueryParamValue (key, value) {
      this.$emit('update-query-param-value', { name: this.paramName, key: key, value: value })
    }
  }
}
</script>
